module.exports = __webpack_public_path__ + "static/media/more-white.06012a00.svg";